export class EnvironmentConfigurations {
    CMS_HOST: string;
    GTM: string;
    MAP_KEY: string;
    ADOBE_SCRIPT?: string;
    IS_ACTIVITY_LOGGING_ENABLED: string;
    IS_AECB_ENABLED: any;
    POSTPAID_PREMIUM_PLAN_TYPE:any;
    B2C_PRORATA_TOTAL_VALUE?:any[];
    CMS_URL_NEW_FRAGMENTPATH: string;
    IS_RAMZAN_DELIVERY_LABEL: boolean;
    IS_VISITOR_LINE_PRE_ARRIVAL_BULK_ACTIVATION: string;
    TRADE_IN_BANAER_CHECKOUT_DISABLE: String;
    CHECK_PREMIUM_PRICE:string;
    BNPL_TABBY_DISABLE:any;
    ENABLE_OTP_AUTHERIZATION_CHECKEOUT:any;
    DISABLE_DEVICE_PURCHASE_ALTERNATE_CONTACT_NO: String;
    DISABLE_NEW_ESIM_FLOW: String;
    MAGENTO_STOREFRONT_CONFIGURATIONS: any;
    IS_FR_MOI_ENABLED:boolean;
    IS_FR_MOI_APP_RELEASE_ENABLED:boolean;
}